<template>
  <v-dialog
    v-model="dialog"
    :persistent="persistent"
    :max-width="maxWidth"
    :scrollable="scrollable"
    :content-class="contentClass"
    :fullscreen="fullscreen"
    :container-class="containerClass"
  >
    <v-card
      :height="cardHeight"
      :max-height="cardMaxHeight"
    >
      <v-card-title class="pa-0 ma-0">
        <span
          v-if="title !== ''"
          class="px-5 py-2"
        >
          {{ title }}
        </span>
        <slot name="title" />
      </v-card-title>
      <v-divider />
      <v-card-text
        ref="scrollContent"
        :class="cardClass"
      >
        <v-container
          :class="containerClass"
          :fluid="fluid"
        >
          <slot />
        </v-container>
      </v-card-text>
      <v-card-actions>
        <slot name="actions" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import DialogClosable from '@/mixins/dialog-closable';

export default Vue.extend({
  name: 'ModalDialog',
  mixins: [DialogClosable],
  props: {
    title: { type: String, required: false, default: '' },
    maxWidth: { type: Number, required: false, default: 600 },
    persistent: { type: Boolean, required: false, default: false },
    cardClass: { type: String, required: false, default: null },
    cardHeight: { type: Number, required: false, default: null },
    cardMaxHeight: { type: String, required: false, default: null },
    scrollable: { type: Boolean, required: false, default: false },
    contentClass: { type: String, required: false, default: null },
    containerClass: { type: String, required: false, default: 'pa-md-5 pa-0' },
    fluid: { type: Boolean, required: false, default: false },
    fullscreen: { type: Boolean, required: false, default: false },
  },
  data() {
    return { };
  },
  watch: { },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    scrollToBottom() {
      const scrollDiv = this.$refs.scrollContent as HTMLElement;
      scrollDiv.scrollTop = scrollDiv.scrollHeight + 60;
    },
  },
});
</script>
